var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        { staticClass: "nav-container" },
        [
          _c("navbar", {
            attrs: { "nav-index": "/addressBook" },
            on: { "nav-items-click": _vm.navClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("sidebar", {
            staticClass: "sidebar-container",
            attrs: { items: _vm.addressBookRouters },
          }),
          _vm._v(" "),
          _c(
            "el-main",
            {
              staticStyle: { padding: "0" },
              attrs: { id: "addressBook-main-container" },
            },
            [_c("app-main")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }